
//////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div style="width:100%;height:100%;position:relative">
  <div class="login-panel-wrapper-background">&nbsp;
  </div>
  <div class="login-panel-wrapper">
    <div class="welcome-central-content">
      <br>
      <br>
      <span class="login-text-title" style="line-height: 20px;">ФК АССОЦИАЦИЯ</span>
    </div>
    <div class="login-panel">
      <div class='login-header'>
        <span class='login-app-title'>{{appSettings.appName}}</span>
        <span class='login-app-ver'>{{appSettings.appVer}}</span>
        <!--span class='login-text-title' v-html="i18n.welcomePage.title"></span>
        <span class='login-text' v-html="i18n.welcomePage.text"></span-->
      </div>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'appSettings'
    ])
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style>
#app .login-panel-wrapper-background {
  width: 100%;
  height: 100%;
  padding-top: 15vh;
  background-color: #f5f5f5;
  background: url('/static/welcome-background-finix.jpg') no-repeat center;
  // -webkit-filter: blur(15px);
  // -moz-filter: blur(15px);
  // filter: blur(15px);
  position:absolute;
  z-index:-1;
}
#app .login-panel-wrapper {
  width: 100%;
  height: 100%;
  padding-top: 15vh;

  position:absolute;
  z-index:1;
}
#app .welcome-central-content {
  width: 65vw;
  padding: 0 8vw 30px 8vw;
  vertical-align: top;
  display: inline-block;
  /*background-color: #00f;*/
  color: rgba(128,128,128,1.0);
  font-size: 13px;
  line-height: 17px;
}
#app .login-panel {
  width: 25vw;
  padding: 20px;
  display: inline-block;
  font-family: "Roboto Light", sans-serif;
  background: rgba(255,255,255,1.0);
  border-radius: 0px;
}

/*****************************************************/

@media screen and (max-height: 550px) {
  #app .login-panel-wrapper {
    padding-top: 5vh;
  }
}
@media screen and (max-height: 450px) {
  #app .login-panel-wrapper {
    padding-top: 1vh;
  }
  #app .welcome-central-content {
    padding-top: 4vh;
  }
}
@media screen and (max-width: 1200px) {
  #app .welcome-central-content {
    width: 60vw;
  }
  #app .login-panel {
    width: 30vw;
  }
}
@media screen and (max-width: 992px) {
  #app .welcome-central-content {
    width: 50vw;
  }
  #app .login-panel {
    width: 40vw;
  }
}
@media screen and (max-width: 768px) {
  #app .login-panel-wrapper {
    height: 125%;
    padding-top: 5vh;
    padding-left: 15vw;
  }
  #app .welcome-central-content {
    width: 70vw;
    padding-top: 0;
    padding-left: 20px;
    padding-right: 20px;
  }
  #app .login-panel {
    width: 70vw;
  }
}

/*****************************************************/

#app .login-header {
  /*margin-bottom: 20px;*/
  color: rgba(128,128,128,1.0);
  /*background: rgba(255,255,255,.0);*/
}

#app .login-text-title {
  display: block;
  font-family: "Lato Thin", sans-serif;
  font-size: 60px;
  color: #fff;
  text-align: left;
  padding-left: 100px;
  padding-bottom: 10px;
}
#app .login-text{
  display: block;
  font-family: "Lato Light", sans-serif;
  line-height: 1.2;
  font-size: 15px;
  text-align: left;
  padding-bottom: 10px;
}

#app .login-app-title {
  display: block;
  font-family: "Lato Thin", sans-serif;
  font-size: 50px;
  color: #999;
  text-align: center;
  padding-bottom: 0px;
}
#app .login-app-ver {
  display: block;
  font-family: "Lato Light", sans-serif;
  font-size: 12px;
  color: #999;
  text-align: center;
  padding: 0 0px 30px 0;
}

/*****************************************************/

#app .login-form-title{
  display: block;
  text-align: left;
  font-family: "Roboto Thin", sans-serif;
  font-size: 23px;
  margin-bottom: 10px;
}
#app .login-form-text{
  display: block;
  text-align: left;
  font-family: "Lato Light", sans-serif;
  font-size: 14px;
  margin-bottom: 20px;
}
#app .login-form-button{
  margin-top: 10px;
}
#app .login-form-links-group{
  margin-top: 15px;
}

</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// Welcome.vue?a769dc42